// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill' //emulate a full ES2015+ environment
import Vue from 'vue'
import App from './App'
import store from './store'
import {get, post} from './libs/tools'
import { Input, Button } from 'element-ui';
import QTips from './components/QTips'
// import vconsole from 'vconsole'
// s尝试调用方法
// import api from 'pages/MainPage'

// fastclick是否使用啊
// import attachFastClick from 'fastclick'
// attachFastClick.attach(document.body)

Vue.prototype.$ELEMENT = { size: 'small' };
// s尝试调用方法
// Vue.prototype.$eapi = new api();
Vue.use(Input);
Vue.use(Button);

// const Vconsole = new vconsole()

// 挂载
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$tips = QTips;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js